<div class="about-page">

    <!-- ========================================================= -->
    <!-- ABOUT HERO                                                -->
    <!-- ========================================================= -->

    <section class="about-hero">

        <div class="about-container">

            <h1 class="about-hero-title" data-reveal data-reveal-delay="100">
                Built on 2,000+
                <span>inspection reports.</span>
            </h1>


            <p class="about-hero-description" data-reveal data-reveal-delay="250">
                speKwo's founder has over 30 years of experience in
                the business, buying, fixing, and selling houses,
                doing remodels for realtors and investors, and
                working through countless inspection reports along
                the way. That experience led to one belief: while
                home inspections are prudent, they also put
                transactions at risk.
            </p>


            <!-- ================================================= -->
            <!-- STATS                                               -->
            <!-- ================================================= -->

            <div class="about-stats" data-reveal data-reveal-delay="400">

                <div class="about-stat">
                    <div class="about-stat-value">
                        2,000+
                    </div>

                    <div class="about-stat-label">
                        REPORTS RECEIVED
                    </div>
                </div>


                <div class="about-stat">
                    <div class="about-stat-value">
                        30+<span>yrs</span>
                    </div>

                    <div class="about-stat-label">
                        OF EXPERIENCE
                    </div>
                </div>


                <div class="about-stat">
                    <div class="about-stat-value">
                        In-house
                    </div>

                    <div class="about-stat-label">
                        REPAIR TEAMS
                    </div>
                </div>


                <div class="about-stat">
                    <div class="about-stat-value">
                        Neutral
                    </div>

                    <div class="about-stat-label">
                        ON EVERY QUOTE
                    </div>
                </div>

            </div>


            <!-- ================================================= -->
            <!-- VIDEO INTRO                                        -->
            <!-- ================================================= -->

            <div class="about-video-intro">

                <div class="about-video-label" data-reveal data-reveal-delay="500">

                    <span></span>

                    <span class="label-text">
                        WATCH THE 45-SEC EXPLAINER
                    </span>

                    <span></span>

                </div>


                <h2 class="about-video-title" data-reveal data-reveal-delay="600">
                    See how it
                    <span>works.</span>
                </h2>


                <div class="about-video-player" data-reveal data-reveal-delay="700" (click)="playVideo()">

                    <video #aboutVideo playsinline preload="none" poster="assets/img/home-one/explainer-poster.png">

                        <source src="assets/img/home-one/spekwo-explainer.mp4" type="video/mp4" />

                    </video>


                    <div class="about-video-overlay" [class.hidden]="videoPlaying">

                        <div class="about-play-button">

                            <svg width="34" height="34" viewBox="0 0 24 24" fill="#fff">
                                <path d="M8 5v14l11-7z"></path>
                            </svg>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </section>


    <!-- ========================================================= -->
    <!-- THE INFAMOUS HOME INSPECTION                              -->
    <!-- ========================================================= -->

    <section class="inspection-section">

        <div class="about-container">

            <div class="section-label centered-label" data-reveal>

                <span></span>

                <span>
                    01 / THE INFAMOUS HOME INSPECTION
                </span>

                <span></span>

            </div>


            <h2 class="section-title inspection-title" data-reveal data-reveal-delay="100">
                Due diligence is where
                <br>
                good deals go to
                <span>die.</span>
            </h2>


            <p class="section-description inspection-description" data-reveal data-reveal-delay="200">
                A home inspection is supposed to protect the deal.
                More often, it's where a clean contract starts to
                come apart. Here's how it usually plays out.
            </p>


            <div class="inspection-grid" data-reveal data-reveal-delay="300">

                <!-- P.01 -->

                <div class="inspection-card">

                    <div class="card-number">
                        P.01
                    </div>

                    <h3>
                        Flagged, not priced
                    </h3>

                    <p>
                        An inspector's job is to find problems, not
                        cost them. So item after item comes back with
                        the same line, "to be assessed by a professional
                        contractor," leaving the buyer and seller to
                        figure out the price on their own.
                    </p>

                </div>


                <!-- P.02 -->

                <div class="inspection-card">

                    <div class="card-number">
                        P.02
                    </div>

                    <h3>
                        Three bids, three totals
                    </h3>

                    <p>
                        Each side lines up their own contractors and
                        the estimates come back wildly different.
                        With no neutral number, nobody trusts any of
                        them and the negotiation stalls.
                    </p>

                </div>


                <!-- P.03 -->

                <div class="inspection-card">

                    <div class="card-number">
                        P.03
                    </div>

                    <h3>
                        The due-diligence clock
                    </h3>

                    <p>
                        All of it has to be resolved inside a short
                        due diligence window, while the contract sits
                        in limbo and the clock runs down.
                    </p>

                </div>


                <!-- P.04 -->

                <div class="inspection-card">

                    <div class="card-number">
                        P.04
                    </div>

                    <h3>
                        And the deal falls apart
                    </h3>

                    <p>
                        Between the guesswork, the mismatched bids,
                        and the ticking clock, buyers get cold feet
                        and walk. A deal that should have closed dies
                        over a repair nobody could put a number on.
                    </p>

                </div>

            </div>

        </div>

    </section>


    <!-- ========================================================= -->
    <!-- WHY SPEKWO                                                 -->
    <!-- ========================================================= -->

    <section class="why-spekwo-section">

        <div class="about-container">

            <div class="section-label" data-reveal>

                <span>
                    02 / WHY SPEKWO
                </span>

                <span></span>

            </div>


            <div class="why-spekwo-grid">

                <!-- LEFT -->

                <div class="why-spekwo-content">

                    <h2 class="section-title" data-reveal data-reveal-delay="100">
                        There was a
                        <span>better way.</span>
                    </h2>


                    <p data-reveal data-reveal-delay="200">
                        Our founders understood the value of home
                        inspections and the frustration of contractors.
                        They believed there was a need for a neutral
                        party providing consistent pricing for items
                        discovered on home inspection reports — clarity
                        and assurance for items that sellers don't want
                        to pay for and buyers are worried about. From
                        that understanding, speKwo was created.
                    </p>


                    <p data-reveal data-reveal-delay="300">
                        We are so confident in the accuracy of our
                        quote we will complete the repairs for the
                        price quoted, with full-time, in-house
                        tradesmen.
                    </p>

                </div>


                <!-- RIGHT -->

                <div class="why-spekwo-features">

                    <!-- Feature 1 -->

                    <div class="why-feature" data-reveal data-reveal-delay="150">

                        <span class="feature-icon phone-icon">
                            ☎
                        </span>

                        <div>

                            <h3>
                                We answer the phone
                            </h3>

                            <p>
                                Whether you're talking through a
                                repair quote or at the closing table,
                                we're available by phone and text.
                            </p>

                        </div>

                    </div>


                    <!-- Feature 2 -->

                    <div class="why-feature" data-reveal data-reveal-delay="250">

                        <span class="feature-icon home-icon">
                            ⌂
                        </span>

                        <div>

                            <h3>
                                We are local to you
                            </h3>

                            <p>
                                Founded in Charlotte, North Carolina.
                                Now serving Asheville, Greater Charlotte,
                                Raleigh, the Triad, and Upstate SC.
                            </p>

                        </div>

                    </div>


                    <!-- Feature 3 -->

                    <div class="why-feature" data-reveal data-reveal-delay="350">

                        <span class="feature-icon tools-icon">
                            ⚒
                        </span>

                        <div>

                            <h3>
                                We know what we're talking about
                            </h3>

                            <p>
                                Everyone on the other end of the line
                                has experience doing the exact repairs
                                you're calling about.
                            </p>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </section>


    <!-- ========================================================= -->
    <!-- OUR TEAM                                                   -->
    <!-- ========================================================= -->

    <section class="team-section">

        <div class="about-container">

            <div class="section-label centered-label" data-reveal>

                <span></span>

                <span>
                    03 / OUR TEAM
                </span>

                <span></span>

            </div>


            <h2 class="section-title team-title" data-reveal data-reveal-delay="100">
                Experts in
                <span>every field</span>
            </h2>


            <p class="section-description team-description" data-reveal data-reveal-delay="200">
                Our office is staffed with experts in every field,
                with extensive experience in building and remodeling
                homes. Schedule a call to simply gain insight into
                your home inspection, or get a quote on any single
                part, or your entire report. While costs of labor
                and materials vary slightly from state to state,
                we are confident we can give you accurate pricing
                to assist you in your next steps.
            </p>


            <!-- ================================================= -->
            <!-- EXPERTISE                                          -->
            <!-- ================================================= -->

            <div class="expertise-list" data-reveal data-reveal-delay="300">

                <span>Structural</span>
                <span>Plumbing</span>
                <span>Electrical</span>
                <span>HVAC</span>
                <span>Roofing</span>
                <span>Interior Repairs</span>
                <span>Exterior Repairs</span>
                <span>Crawlspace</span>

            </div>


            <!-- ================================================= -->
            <!-- TESTIMONIAL CARDS                                  -->
            <!-- ================================================= -->

            <div class="about-testimonials">

                <!-- Judi -->

                <figure class="about-testimonial-card" data-reveal data-reveal-delay="350">

                    <div class="quote-mark">
                        “
                    </div>

                    <blockquote>
                        I always follow up with my clients after they
                        have work completed with your company and I
                        am yet to have any disappointed clients! Your
                        process is easy and convenient to use, which
                        compliments a smooth process for my clients
                        throughout their purchasing process!
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/1/1_Judi%20S.png"
                            alt="Judi S., Keller Williams Ballantyne" />

                        <span>
                            JUDI S. · KELLER WILLIAMS BALLANTYNE
                        </span>

                    </figcaption>

                </figure>


                <!-- Claudia -->

                <figure class="about-testimonial-card" data-reveal data-reveal-delay="470">

                    <div class="quote-mark">
                        “
                    </div>

                    <blockquote>
                        Because I constantly deal with repairs and
                        renovations, I have a pretty good idea of
                        what fair and reasonable contractors charge,
                        and spekwo was exactly that. Since then, I
                        have been using them for my client's deals
                        and highly recommend them.
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/6/6_Claudia%20O.png" alt="Claudia O., Compass" />

                        <span>
                            CLAUDIA O. · COMPASS
                        </span>

                    </figcaption>

                </figure>


                <!-- Zann -->

                <figure class="about-testimonial-card" data-reveal data-reveal-delay="590">

                    <div class="quote-mark">
                        “
                    </div>

                    <blockquote>
                        I have been working with spekwo for four
                        years. In that time they have completed
                        repairs for a number of my clients and
                        completed dozens of quotes for me and everyone
                        on my team. We count on them for our
                        transactions.
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/7/7_Zann%20H.png"
                            alt="Zann H., Coldwell Banker" />

                        <span>
                            ZANN H. · COLDWELL BANKER
                        </span>

                    </figcaption>

                </figure>

            </div>

        </div>

    </section>


    <!-- ========================================================= -->
    <!-- GET STARTED CTA                                            -->
    <!-- ========================================================= -->

    <section class="get-started-section">

        <div class="about-container">

            <div class="get-started-card" data-reveal>

                <h2>
                    Put 2,000+ reports of experience
                    on your side.
                </h2>


                <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="get-started-button">
                    Request a Quote

                    <span>
                        →
                    </span>

                </a>

            </div>

        </div>

    </section>

</div>